import { render, staticRenderFns } from "./batchStop.vue?vue&type=template&id=5304e212&scoped=true"
import script from "./batchStop.vue?vue&type=script&lang=js"
export * from "./batchStop.vue?vue&type=script&lang=js"
import style0 from "./batchStop.vue?vue&type=style&index=0&id=5304e212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304e212",
  null
  
)

export default component.exports